import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CallIcon(props: IconProps) {
    return <Icon {...props} iconKey={"call"}/>
}
